import { useContext, useMemo } from "react";
import { Grid, Paper, Radio, FormHelperText, Typography } from "@mui/material";

import { useEffect } from "react";
import { getPaymentMethods } from "../getPaymentMethods";
import { setDisablePaymentMethodBilling } from "../features";
import { AppContext } from "../contextProviders/AppContext";
import { useTheme } from "@emotion/react";
import { translation } from "./Dictionary";
// Also used at Reservation
const PaymentModeEnum = Object.freeze({
  now: "PENDING",
  now_deposit: "PENDING_DEPOSIT",
  onPickup: "",
});
/* 
const useStyles = makeStyles((theme) => ({
  paymentMethodContainer: {},
  paymentMethod: {
    display: "flex",
    flexDirection: "column",
    maxWidth: 105,
    cursor: "pointer",
    "& img": {
      maxWidth: 105,
      [theme.breakpoints.down('md')]: {
        maxWidth: 80,
      },
    },
    "&:hover": {
      borderColor: "#000000",
    },
  },
})); */

const PaymentMethod = ({ method, classes, formik, confirmationView }) => {
  const theme = useTheme();
  if (confirmationView) {
    return (
      <Grid item>
        <Paper
          variant="outlined"
          //justifyContent="center"
          sx={{
            display: "flex",
            flexDirection: "column",
            maxWidth: 105,
            cursor: "pointer",
            "& img": {
              maxWidth: 105,
              [theme.breakpoints.down("md")]: {
                maxWidth: 80,
              },
            },
            "&:hover": {
              borderColor: "#000000",
            },
          }}
          onClick={() => {
            formik.setFieldValue("paymentMethod", method.name);
            formik.submitForm();
          }}
        >
          <img src={method.img} alt={method.name} />
        </Paper>
      </Grid>
    );
  }
  return (
    <Grid item>
      <Paper
        variant="outlined"
        //justifyContent="center"
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: 105,
          cursor: "pointer",
          "& img": {
            maxWidth: 105,
            [theme.breakpoints.down("md")]: {
              maxWidth: 80,
            },
          },
          "&:hover": {
            borderColor: "#000000",
          },
        }}
        onClick={() => formik.setFieldValue("paymentMethod", method.name)}
      >
        <Grid item>
          <Radio
            size="small"
            checked={formik.values.paymentMethod === method.name}
            onChange={formik.handleChange}
            value={method.name}
            name="paymentMethod"
            inputProps={{ "aria-label": method.name }}
          />
          <img src={method.img} alt={method.name} />
        </Grid>
      </Paper>
    </Grid>
  );
};

const PaymentMethodGroup = ({
  header,
  classes,
  formik,
  confirmationView,
  paymentMethods,
  groups,
}) => {
  return (
    <>
      <Grid item style={{ marginBottom: 15 }}>
        <Typography variant="h5">{header}</Typography>
      </Grid>
      <Grid
        container
        item
        alignItems="center"
        spacing={1}
        /*    className={classes.paymentMethodContainer} */
      >
        {paymentMethods &&
          paymentMethods
            .filter((method) => {
              return groups.includes(method.group);
            })
            .map((method) => {
              return (
                <PaymentMethod
                  method={method}
                  classes={classes}
                  formik={formik}
                  confirmationView={confirmationView}
                  key={method.name}
                />
              );
            })}
      </Grid>
    </>
  );
};

export default function PaymentMethods({
  formik,
  paymentMode,
  paymentMethods,
  setPaymentMethods,
  confirmationView,
}) {
  const { selectedCompany, language } = useContext(AppContext);
  const FEATURE_DISABLE_PAYMENT_METHOD_BILLING = useMemo(() => {
    if (!selectedCompany) return;
    return setDisablePaymentMethodBilling(selectedCompany?.group);
  }, [selectedCompany]);

  useEffect(() => {
    setPaymentMethods(getPaymentMethods(process.env.REACT_APP_ENV));
  }, []);

  return (
    <>
      {(paymentMode === PaymentModeEnum.now ||
        paymentMode === PaymentModeEnum.now_deposit) && (
        <>
          <PaymentMethodGroup
            header={translation.get(language, "Bank fee")}
            /*   classes={classes} */
            formik={formik}
            confirmationView={confirmationView}
            paymentMethods={paymentMethods}
            groups={["banks"]}
          />
          <PaymentMethodGroup
            header={translation.get(language, "Credit cards")}
            /*     classes={classes} */
            formik={formik}
            confirmationView={confirmationView}
            paymentMethods={paymentMethods}
            groups={["creditcards"]}
          />
          <PaymentMethodGroup
            header={translation.get(language, "Other payment methods")}
            /*   classes={classes} */
            formik={formik}
            confirmationView={confirmationView}
            paymentMethods={paymentMethods}
            groups={["wallets"]}
          />
          {!FEATURE_DISABLE_PAYMENT_METHOD_BILLING && (
            <PaymentMethodGroup
              header={translation.get(language, "Pay by invoice")}
              /*   classes={classes} */
              formik={formik}
              confirmationView={confirmationView}
              paymentMethods={paymentMethods}
              groups={["creditinvoices"]}
            />
          )}
          {formik?.errors?.paymentMethod && (
            <Grid item xs={12}>
              <FormHelperText error>
                {formik.errors.paymentMethod}
              </FormHelperText>
            </Grid>
          )}
        </>
      )}
    </>
  );
}
